import { render, staticRenderFns } from "./AdditionalRegionsSelect.vue?vue&type=template&id=1e81afc7&"
import script from "./AdditionalRegionsSelect.vue?vue&type=script&lang=js&"
export * from "./AdditionalRegionsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports